import Vue from 'vue';
import Index from './views/Index';
import router from './router';
import i18n from '@tokenyico/vuejs-toolkit/src/exports/i18n';
import store from './store';
import DsVueJS from '@tokenyico/design-system/vueJS';
import { setLocale } from '@tokenyico/design-system';
import { sentryServiceSetTag, sentryServiceInit } from '@/services/sentry';
import { LoggerService } from '@/services';

// import { makeServer } from '@/services/mocks';

// if (process.env.VUE_APP_ENV === 'development' || process.env.VUE_APP_ENV === 'testing') {
//   makeServer();
// }

const theme = require(`@/assets/themes/${process.env.VUE_APP_THEME_NAME}/themeConfig.json`);

Vue.prototype.$logger = LoggerService;

if (process.env.VUE_APP_ENV === 'production') {
  sentryServiceInit('https://e21eaf2461db40eb9a62d84898cb3750@o144078.ingest.sentry.io/5596704');
  sentryServiceSetTag('token_trader', process.env.VUE_APP_API_URL_TOKEN_TRADER);
  sentryServiceSetTag('user_pool', process.env.VUE_APP_AWS_USER_POOL_ID);
  sentryServiceSetTag('qualification_api', process.env.VUE_APP_API_URL_QUALIFICATION);
  sentryServiceSetTag('release_date', process.env.VUE_APP_BUILD_DATE);
}

Vue.config.productionTip = false;

Vue.use(DsVueJS);

window.app = new Vue({
  router,
  i18n: i18n(store),
  store,
  render: h => h(Index),
  data: () => ({
    isPageLoading: false
  }),
  computed: {
    windowTitle () {
      return 'Qualification Module';
    }
  },
  watch: {
    '$i18n.locale': {
      immediate: true,
      handler: setLocale
    }
  }
}).$mount('#app');

router.beforeEach((to, from, next) => {
  if (to.name) window.app.isPageLoading = true; // loading the asset from the server to render the page
  next();
});

router.afterEach((to, from) => {
  window.app.isPageLoading = false; // finished loading asset
});

/**
 ** Init: Client UI theme
 **/

const html = document.getElementsByTagName('html')[0];
html.style.setProperty('--primary', theme.primary);
html.style.setProperty('--primary-darken', theme.primaryDark);
